<!-- Card de la perspectiva del cliente -->
<div class="card" [ngClass]="{'blue': getColorClientValue(assistancecase.id) == 'blue' ? true : false,
        'red_': getColorClientValue(assistancecase.id) == 'red' ? true : false,
        'yellow_': getColorClientValue(assistancecase.id) == 'yellow' ? true : false,
        'black': getColorClientValue(assistancecase.id) == 'black' ? true : false}">
    <div class="card-body">
        <img alt="" class="img-space-rigth" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/clock-' + (getColorValue(assistancecase.id) || 'black') + '.svg' | company" style="margin-right: 18px;">
        <strong style="margin-right: 5px;">{{ 'Client Perspective' | translate }}:</strong>
        <app-progressbar-timer class="timer-space-left"
            [case_id]="assistancecase.id"
            (timerflag)="setColorClientValue($event)"
            [starttime]="assistancecase.date_start"
            [maxSeconds]="(+assistancecase.services[0].expected_time * 60)"
            [redSeconds]="(+assistancecase.services[0].expected_time * 60)">
        </app-progressbar-timer>
    </div>
</div>

<!-- Card de la perspectiva del Operador -->
<div class="card" [ngClass]="{'blue': getColorOperatorValue(assistancecase.id) == 'blue' ? true : false,
        'red_': getColorOperatorValue(assistancecase.id) == 'red' ? true : false,
        'yellow_': getColorOperatorValue(assistancecase.id) == 'yellow' ? true : false,
        'black': getColorOperatorValue(assistancecase.id) == 'black' ? true : false}">
    <div class="card-body">
        <img alt="" class="img-space-rigth" *ngIf="assistancecase.services[0].id == 332" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-grua.svg' | company" style="margin-right: 18px;">
        <img alt="" class="img-space-rigth" *ngIf="assistancecase.services[0].id == 333" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-llanta.svg' | company" style="margin-right: 18px;">
        <img alt="" class="img-space-rigth" *ngIf="assistancecase.services[0].id == 334" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-corriente.svg' | company" style="margin-right: 18px;">
        <img alt="" class="img-space-rigth" *ngIf="assistancecase.services[0].id == 335" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-gas.svg' | company" style="margin-right: 18px;">
        <img alt="" class="img-space-rigth" *ngIf="assistancecase.services[0].id == 336" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-llave.svg' | company" style="margin-right: 18px;">
        <strong style="margin-right: 5px;">{{ 'Provider Arrival' | translate }}:</strong>
        <app-progressbar-timer class="timer-space-left"
            [case_id]="assistancecase.id"
            (timerflag)="setColorOperatorValue($event)"
            [starttime]="assistancecase.services[0].arrivalStartTime"
            [maxSeconds]="(+assistancecase.services[0].expected_time_customer * 60)" [yellowSeconds]="1"
            [redSeconds]="(+assistancecase.services[0].expected_time_customer * 60)">
        </app-progressbar-timer>
    </div>
</div>
<hr>
<div style="justify-content: center; display: flex;">
    <button (click)="seeTicket()" class="btn secundary-btn btn-margin" style="font-weight: bold; width: 10rem;">
        {{ 'See ticket' | translate }}
    </button>
</div>